import { render, staticRenderFns } from "./CandidateInfo.vue?vue&type=template&id=e22e2e50&"
import script from "./CandidateInfo.vue?vue&type=script&lang=js&"
export * from "./CandidateInfo.vue?vue&type=script&lang=js&"
import style0 from "./CandidateInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports